import { createFileRoute } from '@tanstack/react-router';

import { SupplierDashboardPage } from '@/features/supplier/dashboard-page';

export const Route = createFileRoute('/_app/supplier/$orgId/dashboard')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierDashboardPage {...params} />;
}
